import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'

const LineChart = () => {
  const [startingRent, setStartingRent] = useState([])
  const [effectiveRent, setEffectiveRent] = useState([])
  const [year, setYear] = useState([])

  useEffect(() => {
    const getData = async () => {
      const url =
        'https://633c681b74afaef16408a698.mockapi.io/jamesAondowase/metrics'
      try {
        const response = await fetch(url)
        const data = await response.json()
        console.log(data)
        setStartingRent(data?.map((item) => item.startingRent))
        setEffectiveRent(data?.map((item) => item.effectiveRent))
        setYear(data?.map((item) => item.year))
      } catch (error) {
        console.log(error)
      }
    }
    getData()
  }, [])

  const rents = [
    //data on the y-axis
    {
      name: 'startingRent',
      data: startingRent,
    },
    {
      name: 'effectiveRent',
      data: effectiveRent,
    },
  ]
  const years = {
    //data on the x-axis
    chart: { id: 'rents years' },
    xaxis: {
      categories: year,
    },
  }

  return (
    <div>
      <Chart
        options={years}
        series={rents}
        type='line'
        width='1250'
        height='400'
      />
    </div>
  )
}

export default LineChart
